/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { SuccessorChangeLogHistoryResponseDto } from '../models';
/**
 * SuccessionChangeLogRestApi - axios parameter creator
 * @export
 */
export const SuccessionChangeLogRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get change log history for the employee
         * @param {number} pageSize 
         * @param {number} page 
         * @param {string} [employeeId] 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessorsChangeLogHistory: async (pageSize: number, page: number, employeeId?: string, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getSuccessorsChangeLogHistory', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getSuccessorsChangeLogHistory', 'page', page)
            const localVarPath = `/api/v2/successions/change-log-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuccessionChangeLogRestApi - functional programming interface
 * @export
 */
export const SuccessionChangeLogRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuccessionChangeLogRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get change log history for the employee
         * @param {number} pageSize 
         * @param {number} page 
         * @param {string} [employeeId] 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuccessorsChangeLogHistory(pageSize: number, page: number, employeeId?: string, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessorChangeLogHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuccessorsChangeLogHistory(pageSize, page, employeeId, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionChangeLogRestApi.getSuccessorsChangeLogHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuccessionChangeLogRestApi - factory interface
 * @export
 */
export const SuccessionChangeLogRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuccessionChangeLogRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Get change log history for the employee
         * @param {number} pageSize 
         * @param {number} page 
         * @param {string} [employeeId] 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessorsChangeLogHistory(pageSize: number, page: number, employeeId?: string, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessorChangeLogHistoryResponseDto> {
            return localVarFp.getSuccessorsChangeLogHistory(pageSize, page, employeeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuccessionChangeLogRestApi - interface
 * @export
 * @interface SuccessionChangeLogRestApi
 */
export interface SuccessionChangeLogRestApiInterface {
    /**
     * 
     * @summary Get change log history for the employee
     * @param {number} pageSize 
     * @param {number} page 
     * @param {string} [employeeId] 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionChangeLogRestApiInterface
     */
    getSuccessorsChangeLogHistory(pageSize: number, page: number, employeeId?: string, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessorChangeLogHistoryResponseDto>;

}

/**
 * SuccessionChangeLogRestApi - object-oriented interface
 * @export
 * @class SuccessionChangeLogRestApi
 * @extends {BaseAPI}
 */
export class SuccessionChangeLogRestApi extends BaseAPI implements SuccessionChangeLogRestApiInterface {
    /**
     * 
     * @summary Get change log history for the employee
     * @param {number} pageSize 
     * @param {number} page 
     * @param {string} [employeeId] 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionChangeLogRestApi
     */
    public getSuccessorsChangeLogHistory(pageSize: number, page: number, employeeId?: string, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return SuccessionChangeLogRestApiFp(this.configuration).getSuccessorsChangeLogHistory(pageSize, page, employeeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}

